<div class="d-flex flex-column pm-config-w-header-rb">
  <div class="card-body p-fluid bg-gl-blue-dark pt-2" id="rowBusqueda">
    {{
    (
    type === 'edit'
    ? (
    typeAlert === 'security'
    ? 'ALERTS.MESSAGE.EDIT_VEHICLE_SECURITY_ALERT'
    : typeAlert === 'mobile'
    ? 'ALERTS.MESSAGE.EDIT_MOBILE_SOLUTION_ALERT'
    : typeAlert === '360'
    ? 'ALERTS.MESSAGE.EDIT_FATIGUE_360_ALERT'
    : typeAlert === 'gps'
    ? 'ALERTS.MESSAGE.EDIT_GPS_ALERT'
    : 'ALERTS.MESSAGE.EDIT_PLATFORM_ALERT'
    )
    : (
    typeAlert === 'security'
    ? 'ALERTS.MESSAGE.CREATE_VEHICLE_SECURITY_ALERT'
    : typeAlert === 'mobile'
    ? 'ALERTS.MESSAGE.CREATE_MOBILE_SOLUTION_ALERT'
    : typeAlert === '360'
    ? 'ALERTS.MESSAGE.CREATE_FATIGUE_360_ALERT'
    : typeAlert === 'gps'
    ? 'ALERTS.MESSAGE.CREATE_GPS_ALERT'
    : 'ALERTS.MESSAGE.CREATE_ALERT_PLATFORM'
    )
    ) | translate
    }}
  </div>

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" name="loadingAlertData" size="medium" color="#fff" type="ball-pulse"
    [fullScreen]="false">
    <p style="color: white" class="text-center">
      {{'COMMON.LOADING_INF' | translate}}
    </p>
  </ngx-spinner>
  <div class="modal-body p-fluid flex-grow-1 p-0 overflow-none" style="position: relative; overflow-y: auto;">
    <div class="panel-izq-container-overflow-none h-100">
      <form [formGroup]="alertForm" (submit)="onSubmit($event)" (keydown.enter)="$event.preventDefault()">

        <!--  Campos basica de alerta -->
        <div class="col-12 p-4 card alert-config-card">
          <h5 class="section-title">Configuración básica</h5>
          <div class="row g-3">
            <div class="">
              <div class="col-12 form-label">
                <label>{{ 'ALERTS.LABEL.ALERT' | translate }}:</label>
              </div>
              <div class="col-12">
                <p-dropdown [options]="events" formControlName="tipoAlerta" optionLabel="name"
                  placeholder="Selecciona el tipo de alerta" optionValue="id" [appendTo]="'body'"></p-dropdown>
              </div>
            </div>

            <div class="">
              <div class="col-12 form-label">
                <label>{{ 'ALERTS.LABEL.NAME' | translate }}:</label>
              </div>
              <div class="col-12">
                <input type="text" placeholder="Nombre de la alerta" pInputText formControlName="nombre" />
              </div>
            </div>
          </div>
        </div>

        <!-- Vehiculos -->
        <div class="col-12 p-4 card alert-config-card" [style.opacity]="!eventTypeSelected ? 0.6 : 1">
          <div *ngIf="!eventTypeSelected" class="overlay-block"></div>
          <h5 class="section-title">Vehículos</h5>

          <!-- FILTRO -->
          <div class="row g-3">

            <div class="">
              <div class="col-12 form-label">
                <label>{{ 'COMMON.VEHICLES' | translate }}:</label>
              </div>
              <div class="col-12">
                <div class="p-field">
                  <p-multiSelect [options]="vehicles" optionLabel="label" optionValue="value" formControlName="vehicles"
                    defaultLabel="0 vehículos seleccionados" [appendTo]="'body'" [maxSelectedLabels]="3"
                    [selectedItemsLabel]="'{0} vehículos seleccionados'"></p-multiSelect>
                </div>
              </div>
            </div>

            <div class="cascade-select">
              <div class="col-12 form-label">
                <label>{{ 'GENERAL.FILTER' | translate }}:</label>
              </div>

              <div class="d-flex align-items-center justify-content-between dropdown-trigger-container">
                <!-- Selector principal (abre el árbol) -->
                <div (click)="overlay.toggle($event)" class="dropdown-trigger flex-grow-1">
                  {{ labelDescriptionFilterVehicle || 'Seleccione una opción' }}

                  <div class="d-flex flex-row gap-2 justify-content-center align-items-center">
                    <i class="pi pi-chevron-down ml-2"></i>

                    <!-- Botón para limpiar selección -->
                    <button *ngIf="labelDescriptionFilterVehicle" type="button" class="btn-clear ml-2"
                      (click)="clearTreeSelection($event)">
                      <i class="pi pi-times"></i>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Overlay con árbol -->
              <p-overlayPanel #overlay [style]="{ width: '380px', 'max-height': '40vh', 'overflow-y': 'auto' }"
                appendTo="body">
                <p-tree [value]="treeAssociation" selectionMode="single" [(selection)]="treeAssociationSelected"
                  (onNodeSelect)="selectItemFromAssociation($event)">
                </p-tree>
              </p-overlayPanel>
            </div>
          </div>
        </div>


        <!-- GEOCERCAS -->
        <div *ngIf="showGeocercas" class="col-12 p-4 card alert-config-card"
          [style.opacity]="!eventTypeSelected ? 0.6 : 1">
          <div *ngIf="!eventTypeSelected" class="overlay-block"></div>
          <h5 class="section-title">Geocercas</h5>
          <div class="p-field">

            <div class="col-12 form-label">
              <label>{{ 'COMMON.GEOFENCE' | translate }}:</label>
            </div>
            <div class="col-12">
              <p-multiSelect [options]="geocercasFiltradas" optionLabel="label" optionValue="value"
                formControlName="geocercas" defaultLabel="0 geocercas seleccionadas" [appendTo]="'body'"
                [maxSelectedLabels]="3" [selectedItemsLabel]="'{0} geocercas seleccionadas'">
                <ng-template let-item pTemplate="item">
                  <div class="d-flex align-items-center gap-2 flex-row">
                    <div class="car-item">
                      <div *ngIf="item.type === 'polig'" class="pentagon"
                        [ngStyle]="{ 'background-color': item.color }"></div>
                      <div *ngIf="item.type === 'circ'" class="circle" [ngStyle]="{ 'background-color': item.color }">
                      </div>
                      <div *ngIf="item.type === 'lin'" class="circle" [ngStyle]="{ 'background-color': item.color }">
                      </div>
                    </div>
                    <div>
                      <div>{{ item.label }}</div>
                    </div>
                  </div>
                </ng-template>


              </p-multiSelect>
            </div>

            <div class="col-12">
              <div class="d-flex flex-row gap-2 my-2">
                <p-checkbox (onChange)="selectMoreFiltersGeofences()" [binary]="true"></p-checkbox>
                Aplicar más filtros (geocercas)
              </div>

              <div *ngIf="showMoreFiltersGeocercas" class="filtros-avanzados mb-3 mt-3">
                <div class="row">
                  <!-- Filtro por operaciones -->
                  <div class="col-6">
                    <div class="col-12 form-label">
                      <label>Operaciones:</label>
                    </div>
                    <div class="col-12">
                      <div class="p-field">
                        <p-multiSelect [options]="listOperations" optionLabel="name" optionValue="key"
                          [(ngModel)]="selectedOperations" (onChange)="changeVehicles($event)"
                          [ngModelOptions]="{ standalone: true }" defaultLabel="0 operaciones seleccionadas"
                          [appendTo]="'body'" [selectedItemsLabel]="'{0} operaciones seleccionadas'"></p-multiSelect>
                      </div>
                    </div>
                  </div>

                  <!-- Filtro por etiquetas -->
                  <div class="col-6">
                    <div class="col-12 form-label">
                      <label>Etiquetas:</label>
                    </div>
                    <div class="col-12">
                      <div class="p-field">
                        <p-multiSelect [options]="listEtiquetas" optionLabel="var_name" optionValue="id"
                          [(ngModel)]="selectedEtiquetas" [ngModelOptions]="{ standalone: true }"
                          (onChange)="changeVehicles($event)" defaultLabel="0 etiquetas seleccionadas"
                          [appendTo]="'body'" [selectedItemsLabel]="'{0} etiquetas seleccionadas'"></p-multiSelect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>


        <!-- Configuracion de alerta -->
        <div class="col-12 card p-4 alert-config-card" [style.opacity]="!eventTypeSelected ? 0.6 : 1">
          <div *ngIf="!eventTypeSelected" class="overlay-block"></div>

          <h5 class="section-title">Configuración de alerta</h5>

          <div class="row g-3">
            <!-- Evento activado -->
            <div class="col-md-6">
              <label class="form-label">Evento activado:</label>
              <p-dropdown [options]="booleanOptions" formControlName="chkEventoActivado" optionLabel="label"
                optionValue="value" [appendTo]="'body'" class="w-100"></p-dropdown>
            </div>

            <!-- Ventana emergente -->
            <div class="col-md-6">
              <label class="form-label">{{ 'ALERTS.LABEL.POPUP_WINDOW' | translate }}:</label>
              <p-dropdown [options]="booleanOptionsVentanaEmergente" formControlName="chkVentanaEmergente"
                optionLabel="label" optionValue="value" [appendTo]="'body'" class="w-100"></p-dropdown>
            </div>

            <!-- Sonido del sistema -->
            <div class="col-md-6">
              <label class="form-label">Sonido del sistema:</label>
              <p-dropdown [options]="booleanOptions" formControlName="chkSonido" optionLabel="label" optionValue="value"
                [appendTo]="'body'" class="w-100"></p-dropdown>
            </div>

            <!-- Tipo de sonido -->
            <div class="col-md-6">
              <label class="form-label">{{ 'ALERTS.LABEL.SOUND_TYPE' | translate }}:</label>
              <p-dropdown [options]="listaSonidos" [appendTo]="'body'" optionLabel="label" optionValue="ruta"
                formControlName="sonido" placeholder="Selecciona un sonido..."
                (onChange)="playAudio(alertForm.value.sonido)" class="w-100"></p-dropdown>
            </div>

            <!-- Atención de eventos -->
            <div class="col-md-6 p-field" *appHasPermission="eventAttentionPermission">
              <div class="col-12 form-label">
                <label>Atención de eventos:</label>
              </div>
              <div class="row">
                <div class="col-12">
                  <p-dropdown [options]="booleanOptionsAtencionEventos" formControlName="chkEvaluation"
                    optionLabel="label" optionValue="value" [appendTo]="'body'"></p-dropdown>
                </div>
              </div>
            </div>

            <!-- Infracción -->
            <div *ngIf="showInfraccion" class="col-6 p-field d-flex flex-column justify-content-center">
              <span class="col-12 form-label control-label align-middle">{{ 'ALERTS.LABEL.SET_SPEED_LIMIT' | translate
                }}:</span>
              <div class="row">
                <div class="col-12">
                  <p-inputNumber formControlName="velocidad_limite_infraccion" suffix=" km/h" [placeholder]="'0 km/h'"
                    [min]="0" [max]="1000" [showButtons]="true"></p-inputNumber>
                </div>
              </div>
            </div>

            <!-- Tolerancia en km/h -->
            <div *ngIf="showTolerance" class="col-md-6">
              <div class="row form-label">
                <div class="col p-field d-flex flex-column justify-content-center">
                  <label class="row">
                    <span class="col-9 control-label align-middle">{{ 'ALERTS.LABEL.TOLERANCE' | translate }}:</span>
                    <div class="col-2 d-flex flex-column justify-content-center">
                      <p-checkbox name="groupname" [binary]="true"
                        formControlName="chkFijarLimiteVelocidad"></p-checkbox>
                    </div>
                  </label>
                </div>
              </div>
              <div class="row">
                <div class="col-12 p-field">
                  <p-inputNumber formControlName="velocidad_limite_infraccion" suffix=" km/h" [placeholder]="'0 km/h'"
                    [min]="0" [max]="1000" [showButtons]="true"></p-inputNumber>
                </div>
              </div>
            </div>

            <!-- Tiempo límite -->
            <div *ngIf="showTiempoLimite" class="col-12">
              <div class="time-limit-box p-3">
                <label class="mb-2 form-label d-block">
                  <ng-container *ngIf="alertSelected.slug !== 'exceso-velocidad-duracion-direccion'; else timeLimit">
                    Duración
                  </ng-container>

                  <ng-template #timeLimit>
                    {{ 'ALERTS.LABEL.TIME_LIMIT' | translate }}
                  </ng-template>
                  :
                </label>

                <div class="row">
                  <div class="col p-field">
                    <p-inputNumber formControlName="duracion_parada" [min]="0" [max]="10000" [showButtons]="true"
                      placeholder="Duración"></p-inputNumber>
                  </div>
                  <div class="col p-field">
                    <p-dropdown [options]="timeFormatOptions" formControlName="duracion_formato_parada"
                      optionLabel="label" optionValue="value" [appendTo]="'body'"></p-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div
        class="col-12 card p-4 alert-config-card"
        *ngIf="eventTypeSelected && alertSelected && (alertSelected.slug == 'temperatura' || alertSelected.slug == 'humedad')"
        [style.opacity]="!eventTypeSelected ? 0.6 : 1"
      >
        <div *ngIf="!eventTypeSelected" class="overlay-block"></div>

        <!-- 🔹 Título dinámico -->
        <div class="d-flex flex-row justify-content-between align-items-center section-title">
          <h5 class="">
            Rango de
            {{ alertSelected.slug == 'temperatura' ? 'Temperatura' : 'Humedad' }}
            ({{ alertSelected.slug == 'temperatura' ? '°C' : '%' }})
          </h5>
        </div>

        <div class="row g-3">
          <!-- 🔹 Campo mínimo -->
          <div class="col-md-6">
            <label class="form-label">
              {{ alertSelected.slug == 'temperatura' ? 'Temperatura mínima:' : 'Humedad mínima:' }}
            </label>
            <input
              type="number"
              pInputText
              [formControlName]="'value_min'"
              [placeholder]="
                alertSelected.slug == 'temperatura'
                  ? 'Temperatura mínima (°C)'
                  : 'Porcentaje mínimo'
              "
              [min]="alertSelected.slug == 'temperatura' ? temperatureMinLimit : humidityMinLimit"
              [max]="alertSelected.slug == 'temperatura' ? temperatureMaxLimit : humidityMaxLimit"
            />
          </div>

          <!-- 🔹 Campo máximo -->
          <div class="col-md-6">
            <label class="form-label">
              {{ alertSelected.slug == 'temperatura' ? 'Temperatura máxima:' : 'Humedad máxima:' }}
            </label>
            <input
              type="number"
              pInputText
              [formControlName]="'value_max'"
              [placeholder]="
                alertSelected.slug == 'temperatura'
                  ? 'Temperatura máxima (°C)'
                  : 'Porcentaje máximo'
              "
              [min]="alertSelected.slug == 'temperatura' ? temperatureMinLimit : humidityMinLimit"
              [max]="alertSelected.slug == 'temperatura' ? temperatureMaxLimit : humidityMaxLimit"
            />
          </div>
        </div>

        <!-- 🔹 Rango permitido -->
        <small class="text-muted">
          Ingrese un valor entre
          {{
            alertSelected.slug == 'temperatura'
              ? temperatureMinLimit
              : humidityMinLimit
          }}
          y
          {{
            alertSelected.slug == 'temperatura'
              ? temperatureMaxLimit
              : humidityMaxLimit
          }}.
        </small>
      </div>


      <!-- Configuración Multi-Sensor (solo para multi-temperatura y multi-humedad) -->
      <div
        class="col-12 card p-4 alert-config-card"
        *ngIf="eventTypeSelected && alertSelected && (alertSelected.slug == 'multi-temperatura' || alertSelected.slug == 'multi-humedad')"
        [style.opacity]="!eventTypeSelected ? 0.6 : 1"
      >
        <div *ngIf="!eventTypeSelected" class="overlay-block"></div>
        <!-- Encabezado -->
        <div class="d-flex flex-row justify-content-between align-items-start gap-2">
          <div style="padding: 12px; border-radius: 4px; background-color: aliceblue; border: 1px solid #29b6f6;">
            <i *ngIf="eventTypeSelected && alertSelected && alertSelected.slug == 'multi-temperatura'"
            style="border-radius: 4px; color: #29b6f6" backgroundColor="#fff">
              <svg width="24" height="24" fill="currentColor">
                <use
                  xlink:href="./assets/icons/sprite.svg#thermometer-medium"
                ></use>
              </svg>
            </i>
            <i *ngIf="eventTypeSelected && alertSelected &&  alertSelected.slug == 'multi-humedad'"
              style="border-radius: 4px; color: #29b6f6" backgroundColor="#fff">
            <svg width="24" height="24" fill="currentColor">
              <use
                xlink:href="./assets/icons/sprite.svg#humidity-humid"
              ></use>
            </svg>
            </i>
          </div>
          <div class="multi-sensor-header">
            <h5 class="section-title">
              Configuración de
              {{ alertSelected.slug == "multi-temperatura" ? "Temperatura Multi-Sensor" : "Humedad Multi-Sensor" }}
              <span class="unit-badge">({{ alertSelected.slug == "multi-temperatura" ? "°C" : "%" }})</span>
            </h5>
            <p class="text-muted small mb-0">
              <i class="pi pi-info-circle me-1"></i>
              Configure los rangos de {{ alertSelected.slug == "multi-temperatura" ? "temperatura" : "humedad" }} permitidos para cada sensor.
              Active o desactive sensores según sea necesario.
            </p>
          </div>
        </div>

        <!-- Configuración por Sensor - Estilo imagen -->
        <div class="sensor-config-section">
          <div class="sensor-grid">
            <div
              *ngFor="let sensor of multiSensorData; let i = index"
              class="sensor-card"
              [class.sensor-card-new]="isNewSensor(sensor.sensor)"
            >
              <div class="sensor-header">
                <div class="sensor-title gap-2 d-flex align-items-center">
                  <i class="pi pi-book me-2"></i>
                  <div>Sensor {{ sensor.sensor }}</div>
                  <div style="padding: 4px; border-radius: 4px; text-align: center;" [style.backgroundColor]="sensor.active ? '#90ee9061' : '#80808061'" [style.color]="sensor.active ? 'green' : 'gray'">
                    <span class="toggle-label">{{ sensor.active ? 'Activo' : 'Inactivo' }}</span>
                  </div>
                </div>
                <!-- Botón eliminar -->
                <button  pButton pRipple type="button"
                  class="p-button-outlined p-button-danger"
                  icon="pi pi-trash"
                  (click)="removeSensor(i)"
                  *ngIf="multiSensorData.length > 1"
                >
                </button>
              </div>
              <!-- Layout en fila: Switch + Campos de valores -->
              <div class="sensor-row">
                <!-- Switch de activación/desactivación -->
                <div class="sensor-toggle-wrapper">
                  <div class="sensor-toggle">
                    <span class="toggle-label">{{ sensor.active ? 'Activo' : 'Inactivo' }}</span>
                    <p-inputSwitch 
                      [(ngModel)]="sensor.active"
                      [ngModelOptions]="{ standalone: true }"
                      (onChange)="onSensorToggleChange(i)"
                    ></p-inputSwitch>
                  </div>
                </div>
                <div class="sensor-values">
                  <!-- Valor Mínimo -->
                  <div class="value-group">
                    <label class="value-label">
                      {{ alertSelected.slug == "multi-temperatura" ? "Temp. mínima:" : "Humedad mínima:" }}
                    </label>
                    <div class="value-input-wrapper">
                      <!-- <span class="value-unit">M</span> -->
                      <p-inputNumber
                        [ngModel]="sensor.value_min"
                        (ngModelChange)="updateSensorValue(i, 'value_min', $event)"
                        [ngModelOptions]="{ standalone: true }"
                        [min]="getMinLimit()"
                        [max]="getMaxLimit()"
                        [placeholder]="'Mín'"
                        [showButtons]="false"
                        styleClass="w-100"
                        [suffix]="getUnitLabel()"
                      ></p-inputNumber>
                    </div>
                  </div>

                  <!-- Valor Máximo -->
                  <div class="value-group">
                    <label class="value-label">
                      {{ alertSelected.slug == "multi-temperatura" ? "Temp. máxima:" : "Humedad máxima:" }}
                    </label>
                    <div class="value-input-wrapper">
                      <!-- <span class="value-unit">M</span> -->
                      <p-inputNumber
                        [ngModel]="sensor.value_max"
                        (ngModelChange)="updateSensorValue(i, 'value_max', $event)"
                        [ngModelOptions]="{ standalone: true }"
                        [min]="getMinLimit()"
                        [max]="getMaxLimit()"
                        [placeholder]="'Máx'"
                        [showButtons]="false"
                        styleClass="w-100"
                        [suffix]="getUnitLabel()"
                      ></p-inputNumber>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

            <!-- Botón Añadir nuevo sensor -->
        <div class="add-sensor-container">
          <div class="add-sensor-wrapper w-100">
            <button 
              type="button" 
              class="btn btn-add-sensor w-100"
              (click)="addNewSensor()"
              [disabled]="multiSensorData.length >= 8"
            >
              <i class="pi pi-plus-circle me-2"></i>
              Añadir nuevo sensor
            </button>
            <!-- <span class="sensor-limit-info" *ngIf="multiSensorData.length < 8">
              <i class="pi pi-info-circle me-1"></i>
              Puede agregar hasta 8 sensores
            </span> -->
            <!-- <span class="sensor-limit-info max-reached" *ngIf="multiSensorData.length >= 8">
              <i class="pi pi-exclamation-circle me-1"></i>
              Límite máximo de 8 sensores alcanzado
            </span> -->
          </div>
        </div>

          <!-- Información de rango permitido -->
          <small class="text-muted d-block mt-3 d-flex align-items-start">
            <i class="pi pi-info-circle me-2" style="color: #29b6f6;"></i>
            <div>
              <span>Ingrese valores entre {{ getMinLimit() }} y {{ getMaxLimit() }}{{ getUnitLabel() }}.</span>
              <span>Al menos uno de los valores (mínimo o máximo) debe estar configurado para cada sensor.</span>
            </div>
          </small>
        </div>
      </div>
        <!-- Notificacion de Correo -->
        <div class="col-12 card p-4 alert-config-card" *appHasPermission="emailNotificationPermission"
          [style.opacity]="!eventTypeSelected ? 0.6 : 1">
          <div *ngIf="!eventTypeSelected" class="overlay-block"></div>

          <div class="d-flex flex-row justify-content-between align-items-center section-title">
            <h5 class="">Notificación por correo</h5>
            <div class="d-flex flex-column justify-content-center">
              <div class="form-check">
                <p-checkbox inputId="binary" name="groupname" [binary]="true" formControlName="chkCorreo"></p-checkbox>
              </div>
            </div>
          </div>
          <div class="row g-3">
            <!-- Input + botón -->
            <div class="p-inputgroup email-input-group">
              <!-- Input -->
              <input type="email" pInputText placeholder="Correo electrónico" formControlName="email"
                (keydown.enter)="addEmail()" name="email" class="w-100" />

              <!-- Botón icono "+" -->
              <button type="button" class="btn-icon" (click)="addEmail()" aria-label="Añadir Email"
                [disabled]="!alertForm.value.chkCorreo">
                <i class="pi pi-plus"></i>
              </button>
            </div>
            <!-- Emails añadidos como badges -->
            <div class="d-flex flex-wrap gap-2">
              <ng-container *ngFor="let email of alertForm.value.lista_emails; let i = index">
                <span class="p-chip p-chip-text">
                  {{ email }}
                  <i class="pi pi-times mr-2 remove-icon" (click)="removeEmail(i)" style="font-size: 0.9rem;"
                    title="Eliminar"></i>
                </span>
              </ng-container>
            </div>
          </div>
        </div>


        <!-- Notificación por WhatsApp -->
        <ng-container *appHasPermission="whatsappNotificationPermission">

          <div *ngIf="showWhatsApp" class="col-12 card p-4 alert-config-card"
            [style.opacity]="!eventTypeSelected ? 0.6 : 1">
            <div *ngIf="!eventTypeSelected" class="overlay-block"></div>
            <div class="d-flex flex-row justify-content-between align-items-center section-title mb-3">
              <h5 class="m-0">Notificación por WhatsApp</h5>
              <div class="form-check">
                <p-checkbox inputId="chkWhatsapp" name="chkWhatsapp" [binary]="true"
                  formControlName="chkwhatsapp"></p-checkbox>
              </div>
            </div>

            <!-- Entrada de número de WhatsApp -->
            <div class="row g-3" *ngIf="typeAlert === '360'">
              <div class="col-12">
                <div class="d-flex align-items-stretch gap-2">
                  <!-- Código de país -->
                  <p-dropdown [options]="codes" optionLabel="label" optionValue="code" [(ngModel)]="codeSelected"
                    [autoDisplayFirst]="true" [filter]="true" filterBy="name" [disabled]="!alertForm.value.chkwhatsapp"
                    [ngModelOptions]="{ standalone: true }" placeholder="Código" class="w-4"></p-dropdown>

                  <!-- Número -->
                  <p-inputNumber maxlength="9" name="whatsapp" [useGrouping]="false" formControlName="whatsapp"
                    placeholder="Número" class="flex-fill" (keydown.enter)="addWhatsapp()"></p-inputNumber>

                  <!-- Botón "+" -->
                  <button type="button" class="btn-add-email" (click)="addWhatsapp()"
                    [disabled]="!alertForm.value.chkwhatsapp" aria-label="Añadir número de WhatsApp">
                    <i class="pi pi-plus"></i>
                  </button>
                </div>
              </div>
              <div class="col-12">
                <div class="d-flex flex-wrap gap-2">
                  <ng-container *ngFor="let whatss of alertForm.value.lista_whatsapp; let i = index">
                    <span class="p-chip p-chip-text">
                      {{ whatss }}
                      <i class="pi pi-times mr-2 remove-icon" (click)="removeWhatsapp(i)" style="font-size: 0.9rem;"
                        title="Eliminar"></i>
                    </span>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Controles finales -->
        <div class="row justify-content-center mt-4 mb-5 panel-izq-container-footer">
          <div class="col-6">
            <button type="button" class="btn-gl-cancel btn-dark-hover w-100" ui-sref="alertas-accesorios"
              (click)="clickShowPanel()">
              {{'GENERAL.CANCEL' | translate}}
            </button>
          </div>
          <div class="col-6">
            <button type="submit" class="btn-gl-save btn-dark-hover w-100" [disabled]="loadingEventSelectInput">
              {{'GENERAL.SAVE' | translate}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
